import { useEffect, useState } from "react";
import dayjs from "dayjs";

const calcularRestante = (alvo) => {
  if (!alvo) {
    return { expirado: true, horas: 0, minutos: 0, segundos: 0 };
  }

  const diff = dayjs(alvo).diff(dayjs());
  if (diff <= 0) {
    return { expirado: true, horas: 0, minutos: 0, segundos: 0 };
  }

  return {
    expirado: false,
    horas: Math.floor(diff / 3600000),
    minutos: Math.floor((diff % 3600000) / 60000),
    segundos: Math.floor((diff % 60000) / 1000),
  };
};

export default function useVencimentoCountdown(alvo) {
  const [restante, setRestante] = useState(() => calcularRestante(alvo));

  useEffect(() => {
    if (!alvo) {
      setRestante({ expirado: true, horas: 0, minutos: 0, segundos: 0 });
      return undefined;
    }

    const tick = () => setRestante(calcularRestante(alvo));
    tick();
    const timer = setInterval(tick, 1000);
    return () => clearInterval(timer);
  }, [alvo]);

  return restante;
}
